import shopify from "../../js/shopify";
import hasher from "../../js/alpine/stores/hasher";

const useCustomerActivationCheck = () => {
    const checkCustomerActivationStatus = async (email) => {
        try {
            const customerQuery = {
                query: hasher.store().getQuery('customer_activation_check'),
                variables: {
                    query: "email:"+email
                }
            }

            const fetchDetails = {
                options: {
                    method: 'POST',
                    headers: {
                        'X-Shopify-Access-Token': '<SHOPIFY_API_AUTHENTICATED_KEY>',
                        'Content-Type': 'application/json',
                        'X-MindArc-Hash': hasher.store().getHash('customer_activation_check'),
                    },
                    body: JSON.stringify(customerQuery),
                    request_body: customerQuery.query,
                },
            }

            const response = await shopify.authenticatedFetch(fetchDetails, "2025-07");
            
            if (response.errors) {
                throw new Error('Failed to check customer status');
            }

            const customers = response.data?.customers?.edges || [];
            
            if (customers.length === 0) {
                return {
                    exists: false,
                    message: "No account found with this email address."
                }
            }

            const customer = customers[0].node;

            if (customer.state === 'DISABLED' || customer.state === 'INVITED') {
                const activationResult = await sendActivationEmail(customer.id);
                
                if (activationResult.success) {
                    return {
                        exists: true,
                        isActivated: false,
                        activationEmailSent: true,
                        message: "A request to activate your account has been sent to your email. Please follow the instruction on the email to complete your account set-up."
                    }
                } else {
                    return {
                        exists: false
                    }
                }
            }

        } catch (err) {
            return {
                exists: false,
                error: err.message || 'Failed to check customer activation status'
            }
        }
    }

    const sendActivationEmail = async (customerId) => {
        try {
            // Use the customer account invitation mutation to send activation email
            const invitationMutation = {
                query: hasher.store().getQuery('customer_send_account_invite'),
                variables: {
                    customerId: customerId
                }
            }

            const fetchDetails = {
                options: {
                    method: 'POST',
                    headers: {
                        'X-Shopify-Access-Token': '<SHOPIFY_API_AUTHENTICATED_KEY>',
                        'Content-Type': 'application/json',
                        'X-MindArc-Hash': hasher.store().getHash('customer_send_account_invite'),
                    },
                    body: JSON.stringify(invitationMutation),
                    request_body: invitationMutation.query,
                },
            }

            const response = await shopify.authenticatedFetch(fetchDetails, "2025-07");
            
            if (response.errors || response.data?.customerSendAccountInviteEmail?.userErrors?.length > 0) {
                console.error('Failed to send activation email:', response);
                return { success: false }
            }

            return { success: true }

        } catch (err) {
            console.error('Send activation email error:', err);
            return { success: false }
        }
    }

    return { checkCustomerActivationStatus }
}

export default useCustomerActivationCheck;
